<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">User Management</h2>
    </div>
    <form class="needs-validation pt-1 my-2 " @submit.prevent="getUsers">
      <div class=" form-group row justify-content-between m-0" >
        <div class="mx-3 my-1">

        <label class="col-form-label mr-3">Tenants</label>

          <dropdownlist
          class="my-2"
            ref="tenantDropdown"
            :data-items="tenants"
            :text-field="'name'"
            :data-item-key="'id'"
            :default-value="tenants[0]"
            @change="onSelectTenant"
          >
          </dropdownlist>
          <button
            type="submit"
            value="Search"
            class="k-button k-secondary btn mx-4 py-1"
          >
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>

        <div class="my-auto mx-auto mx-sm-2">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="users">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left">
        </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="userInEdit"
        :data-source-array="dataSourceArray"
        :dialog-title="dialogTitle"
        :tenants="tenants"
        :data-item="userInEdit"
        :selected-identity="selectedIdentity"
        :selected-tenant="selectedTenant"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "id", dir: "asc" }],
      users: undefined,
      userInEdit: undefined,
      tenants: [],
      selectedIdentity: undefined,
      selectedTenant: undefined,
      tempIdentity: this.identity,
      tempTenant: undefined,
      skip: 0,
      take: 10,
      columns: [
        {
          field: "userName",
          title: "User Name",
          width: "150px",
        },
        { field: "email", title: "Email", width: "150px" },

        { field: "phoneNumber", title: "Phone Number", width: "150px" },

        { field: "roles", title: "Roles", cell: this.listRoles },

        { field: "tenantName", title: "Tenant Name" },

        { cell: "myTemplate", width: "150px" },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${this.userInEdit.id === undefined ? "Add" : "Edit"} user`;
    },
    result: {
            get: function() {
                return this.users.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.users ? this.users.length : 0;
    }
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if(this.tempIdentity!=null)
    {
      this.getTenants();
    }
  },
  watch:{
    identity:function(){
      this.tempIdentity=this.identity;
      this.tempTenant = undefined;
      this.$refs.tenantDropdown.currentValue = this.tenants[0];
     this.getTenants();
    }
  },
  methods: {
    pageChangeHandler: function(event) {
            this.skip = event.page.skip;
            this.take = event.page.take;
        },
    async getUsers() {
      this.selectedIdentity = this.tempIdentity;
      this.selectedTenant = this.tempTenant;
      try {
        const response = await axios.get(this.base_url + "User/GetUsers/"+this.selectedIdentity.id+"/"+this.selectedTenant.id);
        this.users = response.data.result;
        console.log(response.data.message);
        this.getRoles();
      } catch (err) {
        console.log(err);
      }
    },
    async getTenants() {
        if(this.tempIdentity==null)
          return;
        else
        {
      try {
        const client_id = oidcSettings.client_id;
        const response = await axios.get(this.base_url + "Tenant/GetTenants/"+this.tempIdentity.id);
        this.tenants = response.data.result;
        this.tenants.unshift({id:" ",name:"No Tenant"});
        this.tempTenant=this.tenants[0];
        this.getUsers();
      } catch (err) {
        console.log(err);
      }    
      }
    },
    onSelectTenant(event) {
      console.log("change", event.target.value);
      this.tempTenant = event.target.value;
    },
    listRoles(h, tdElement, props, listeners) {
      var roles = props.dataItem.roles.map((role) => role.roleName);
      roles = roles.join(",");
      console.log(roles);
      console.log("roles");
      return h("td", [roles]);
    },
    edit(dataItem) {
      this.userInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
        const client_id = oidcSettings.client_id;

        const response = await axios.delete(this.base_url + "User/DeleteUser/"+
            dataItem.id +"/"+
            this.selectedIdentity.id +"/"+
            this.selectedTenant.id,
         );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        this.showMsg = true;
        this.userData = {};
        //this.$router.push("/home");
        this.users = this.users.filter((p) => p.id !== dataItem.id);
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async save() {
      const dataItem = this.userInEdit;
      const users = this.users.slice();
      const isNewUser = dataItem.id === undefined;
      const client_id = oidcSettings.client_id;
      let data = {
        Id: dataItem.id,
        UserName: dataItem.userName,
        Email: dataItem.email,
        PhoneNumber: dataItem.phoneNumber,
        PasswordHash: dataItem.password,
        Roles: dataItem.roles,
        TenantID:dataItem.tenantID,
        TwoFactorEnabled:dataItem.twoFactorEnabled,
        IsActive: dataItem.isActive,
        SmsChannelKey: dataItem.smsChannelKey,
        EmailChannelKey: dataItem.emailChannelKey,
      };
      if (isNewUser) {
        try {
          const response = await axios
            .post(this.base_url + "User/AddUser/"+this.selectedIdentity.id+"/"+client_id+"/"+dataItem.tenantID,
             data)
            .then((response) => {
              var newUser = response.data.result;
              users.unshift(newUser);
            });
          this.status = response.data.status;
          this.responseMsg = response.data.message;
          this.showMsg = true;
          this.userData = {};
          //this.$router.push("/home");
        } catch (err) {
          console.log("Ooops!" + err);
        }
      } else {
        try {
          //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
          const response = await axios.put(
            this.base_url + "User/UpdateUser/"+this.selectedIdentity.id+"/"+this.selectedTenant.id,
            data,
          );
          this.status = response.data.status;
          this.responseMsg = response.data.message;
          this.showMsg = true;
          this.userData = {};
          const index = users.findIndex((p) => p.id === dataItem.id);
          users.splice(index, 1, dataItem);
        } catch (err) {
          console.log("Ooops!" + err);
        }
      }

      this.users = users;
      this.userInEdit = undefined;
    },
    cancel() {
      this.userInEdit = undefined;
    },
    insert() {
      this.userInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
    newUser(source) {
      const id =
        this.users.reduce((acc, current) => Math.max(acc, current.id || 0), 0) +
        1;
      const newUser = {
        id: id,
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        roles: [],
      };

      return Object.assign(newUser, source);
    },
    getRoles: async function () {
      //const response = await axios.get("https://localhost:5001/api/IdentityPool/GetIdentityPools");
      const client_id = oidcSettings.client_id;

      const response = await axios.get(
        this.base_url + "Role/GetRoles/"+this.selectedIdentity.id,
      );
      this.dataSourceArray = response.data.result;
      console.log("Roles : ", this.dataSourceArray);
      var current = this;
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}

.needs-validation {
  background: white;
}
</style>